import Icon from 'lqa-ui/lib/Components/Icon';
import React, { useState } from 'react';
import './styless.scss';
import { Collapse } from 'react-collapse';
import { useNavigate } from 'react-router-dom';

const SettingsCard = () => {
    const navigate = useNavigate();
    const [toggle, setToggle] = useState(false);
    const handleCollapsible = () => {
        setToggle(!toggle);
      };
    const settingClickHandler = () => {
      navigate('/settings');
    };
    return(
        <div className="w-90">
            <div className="setting-container">
            <h2 className="fw-600 f-22 lh-28 color-1F1F1F"> Settings</h2>
            <span className="mr-22 mt-10">
              <Icon height={22} width={22} kind={toggle ? 'arrow-up' : 'arrow-down'}  onClick={handleCollapsible} />
            </span>
            </div>
            <Collapse isOpened={toggle}>
              <div className="setting-content-container" onClick={settingClickHandler}>
                <span className="d-flex align-items-center">
                  <Icon kind="security-lock" height={22} width={20} />
                  <span className="fw-400 f-18 lh-22 color-1F1F1F ml-10">Security</span>
                </span>
                <Icon kind="arrow-right" height={17} width={17} />
              </div>
            </Collapse>
        </div>
    );
};

export default SettingsCard;
